import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Interest } from 'src/app/interfaces/interest';
import { EnvironmentService } from 'src/app/services/environment.service';
import { InterestService } from 'src/app/services/interest.service';
import { OverlayService } from 'src/app/services/overlay.service';
import * as uuid from 'uuid';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentInterest implements OnInit {
  /**
   * The Form to add a Interest
   */
  addForm: UntypedFormGroup;
  /**
   * The State an Interest can have
   */
  public stateOptions = [
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
  ]
  /**
   * constructor
   * Init the Form
   * @param interestService 
   * @param fb 
   * @param env 
   * @param overlayService 
   * @param router 
   */
  constructor(
    private interestService: InterestService,
    private fb: UntypedFormBuilder,
    private env: EnvironmentService,
    private overlayService: OverlayService,
    private router: Router) {
    this.addForm = this.fb.group({
      name: ['', [Validators.required]],
      state: ['', [Validators.required]]
    })
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {

  }
  /**
   * Createa new Interest
   * @returns 
   */
  createInterest() {
    this.addForm.markAllAsTouched();
    if (this.addForm.invalid) {
      return;
    }
    let t: Interest = {
      name: this.addForm.value.name,
      state: this.addForm.value.state,
      publicId: uuid.v4(),
      clientRef: Number(this.env.getClientId())
    }
    this.interestService.createInterest(t).subscribe(() => {
      this.overlayService.openSnackBar("Interesse erfolgreich angelegt!");
      this.router.navigateByUrl('caseworker/interest');
    })
  }
}
